var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.27051C9.1 2.27051 10 3.17051 10 4.27051C10 5.37051 9.1 6.27051 8 6.27051C6.9 6.27051 6 5.37051 6 4.27051C6 3.17051 6.9 2.27051 8 2.27051ZM8 11.2705C10.7 11.2705 13.8 12.5605 14 13.2705V14.2705H2V13.2805C2.2 12.5605 5.3 11.2705 8 11.2705ZM8 0.270508C5.79 0.270508 4 2.06051 4 4.27051C4 6.48051 5.79 8.27051 8 8.27051C10.21 8.27051 12 6.48051 12 4.27051C12 2.06051 10.21 0.270508 8 0.270508ZM8 9.27051C5.33 9.27051 0 10.6105 0 13.2705V16.2705H16V13.2705C16 10.6105 10.67 9.27051 8 9.27051Z",
    fill: "#4B4B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUser);
export default __webpack_public_path__ + "static/media/profile-user.39529bb3b4ff6351b3d13f2140dd16e6.svg";
export { ForwardRef as ReactComponent };